import React, { Component } from 'react';
import BrowseNavigation from '../components/browse/BrowseNavigation';
import PropTypes from 'prop-types';
import dataComponent from '../hoc/dataComponent';
import { loadInstruments } from '../actions/instrument';
import { loadGenres } from '../actions/genre';
import { loadEpochs } from '../actions/epoch';
import CapacitorSkeletonIfLoading from '../components/capacitor/SkeletonIfLoading';
import stylesBrowse from './Browse.css';

class Browse extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="u-page-container">
        <div className={stylesBrowse.view}>
          <h1 className="sr-only">Browse</h1>
          <BrowseNavigation />
          <CapacitorSkeletonIfLoading noInsets>{this.props.children}</CapacitorSkeletonIfLoading>
        </div>
      </div>
    );
  }
}

function fetchData(store) {
  // Even though the content of the page is coming from files in /data/* as
  // hardcoded values, we still load the backend data, to not show links to
  // browse data that might have been deleted on the backend and would result
  // in 404.
  return [
    store.dispatch(loadInstruments()),
    store.dispatch(loadGenres()),
    store.dispatch(loadEpochs()),
    __CAPACITOR__ && store.dispatch({ type: 'RESET_QUICK_SEARCH' }),
  ].filter(Boolean);
}

export default dataComponent(fetchData)(Browse);
